import { createSelector } from "reselect";
import RD from "../../utils/functional/remote-data";

const getAuthState = (state) => state.meta.loggedUser;

export const getLoggedUser = createSelector(getAuthState, (authState) => ({
  isAuthenticated: RD.isSuccess(authState),
  isAuthenticating: RD.isLoading(authState),
  error: authState.error,
}));

export const getLoggedUserPermissions = createSelector(
  getAuthState,
  RD.case({
    success: (token) => JSON.parse(atob(token.split(".")[1])).scope.split(" "),
    _: () => [],
  })
);
